module.exports = __webpack_public_path__ + "img/logo.721155dc.png";